import { Layers } from '../models/layers.enum';
import { MapLayerRenderer } from '../mapbox-map-layer-renderer';
import { LineLayerOptions, IconLayerOptions } from '../models';
import { Theme } from 'src/app/modules/shared/models';
import { MapboxHelper } from '../mapbox-map-helper';

// eslint-disable-next-line no-shadow
export enum LineColor {
    active = '#39a935',
    ordinaryOverriden = '#ffcc00',
    ordinary = '#39a935'
}

export class RenderLinesLayer extends MapLayerRenderer {
    constructor(
        protected _mapboxHelper: MapboxHelper,
        private _theme: Theme = Theme.Light,
        private _layer: Layers
    ) {
        super(_mapboxHelper);
    }

    protected modifyFeatureCollection(fc: GeoJSON.FeatureCollection): GeoJSON.FeatureCollection {
        return fc;
    }

    protected renderLayers(map: mapboxgl.Map): void {
        const layers = {};
        layers[this._layer] = [];

        const linesLayerId = `${this._layer}`;
        if (!this._mapboxHelper.layerExists(map, linesLayerId)) {
            let layerNames = [];
            const options = this._lineOptions();
            layerNames = this._mapboxHelper.renderLineLayer(map, this._sourceId, this._sourceLayer, linesLayerId, options);
            layers[this._layer] = layers[this._layer].concat(layerNames);
        }

        const linesLayerArrowsId = `${this._layer}-arrow`;
        if (!this._mapboxHelper.layerExists(map, linesLayerArrowsId)) {
            let layerNames = [];
            const options = this._lineArrowOptions();
            layerNames = this._mapboxHelper.renderIcon(map, this._sourceId, this._sourceLayer, linesLayerArrowsId, options);
            layers[this._layer] = layers[this._layer].concat(layerNames);
        }

        this.addLayerNames(layers);
    }

    //#region rendering options for layers connected to log
    private _lineOptions(): LineLayerOptions {
        const options = new LineLayerOptions();
        options.color = [
            'case',
            [
                '==',
                ['get', 'discrete'],
                true
            ],
            // if discrete => gray
            '#7A7A7A',
            [
                '==',
                ['get', 'discrete'],
                false
            ],
            // if not discrete => blue
            '#0078D7',
            // default => blue
            '#0078D7'
        ];
        options.sort = 'zIndex';
        options.opacity = 1;

        options.lineWidth = [
            'interpolate',
            ['linear'],
            ['zoom'],
            0,
            [
                'case',
                [
                    '==',
                    ['get', 'wideLine'],
                    true
                ],
                10,
                [
                    '==',
                    ['get', 'wideLine'],
                    false
                ],
                1.5,
                1.5
            ],

            12,
            [
                'case',
                [
                    '==',
                    ['get', 'wideLine'],
                    true
                ],
                10,
                [
                    '==',
                    ['get', 'wideLine'],
                    false
                ],
                3,
                3
            ],

            15,
            [
                'case',
                [
                    '==',
                    ['get', 'wideLine'],
                    true
                ],
                10,
                [
                    '==',
                    ['get', 'wideLine'],
                    false
                ],
                7,
                7
            ],

            22,
            [
                'case',
                [
                    '==',
                    ['get', 'wideLine'],
                    true
                ],
                10,
                [
                    '==',
                    ['get', 'wideLine'],
                    false
                ],
                8,
                8
            ]
        ];

        options.visibility = true;

        // border
        options.borderWidth = [
            'interpolate',
            ['linear'],
            ['zoom'],
            0,
            2,

            12,
            5,

            15,
            12,

            22,
            14
        ];
        options.borderOpacity = 0.65;
        options.border = true;
        options.borderColor = '#ffffff';
        // Position before StopsTileset so StopsTileset renders on top
        options.layerBefore = Layers.StopsTileset;
        return options;
    }

    private _lineArrowOptions(): IconLayerOptions {
        const options = new IconLayerOptions();
        // Position before StopsTileset so StopsTileset renders on top
        options.layerBefore = Layers.StopsTileset;
        options.icon = this._theme === Theme.Light ? 'oneway-white-small' : 'oneway-small';
        options.iconSize = 0.5;
        options.iconRotationAlignment = 'auto';
        options.iconRotate = false;
        options.symbolPlacement = 'line';
        options.symbolSpacing = 100;
        options.useDefaultPointFilter = false;
        options.visibility = true;
        return options;
    }
    //#endregion
}
